import { Box } from "@mui/material";
import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";

const Summary = (props) => {
  const { title = "", items = [] } = props;

  return (
    <Box
      component="nav"
      className="fr-summary"
      role="navigation"
      aria-labelledby="fr-summary-title"
      sx={{ width: { xs: "100%", lg: "19rem" } }}
    >
      <h2 className="fr-summary__title">{title}</h2>
      <ol>
        {items.map((item) => (
          <li key={item.link}>
            <Link
              className="fr-summary__link"
              anchor={item.link}
              title={item.title}
              sx={{ "&::before": { top: { xs: "-2px", lg: "-1.5px" } } }}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ol>
    </Box>
  );
};

Summary.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
};

export default Summary;
